import AbstractEntity from "../AbstractEntity";

/**
 * @rule-checker exclude
 */
export default class Order extends AbstractEntity {
    static STATUS_TO_SUGGEST = 0;
    static STATUS_SUGGESTED = 1;
    static STATUS_WAIT_IN_PROGRESS = 2;
    static STATUS_CLOSE = 3;
    static STATUS_VALIDATE = 4;

    static END_INITIATOR_INTERNAL = 1;
    static END_INITIATOR_PRESCRIBER = 2;
    static END_INITIATOR_CLIENT = 3;

    static END_REASON_NOT_CONFORMITY = 1;
    static END_REASON_KEY_RETRIEVED = 2;
    static END_REASON_CLIENT_NO_REPLY = 3;
    static END_REASON_NO_DETAILS = 4;
    static END_REASON_DUPLICATES = 5;
    static END_REASON_INSUFFICIENT_SUPPORTED_PRICE = 6;
    static END_REASON_REFUSE_CLIENT_PRICE = 7;
    static END_REASON_REMOTE_QUOTATION = 8;
    static END_REASON_OUT_OF_ZONE = 9;

    _id;
    _prescriberId;
    _workId;
    _externalId;
    _orderComment;
    _prescriberComment;
    _maxPrice;
    _maxPriceSupportPart;
    _status;
    _endInitiator;
    _endReason;
    _clientContacted;
    _crcSent;
    _crcContent;
    _lastTimeUnattributed;
    _insuranceName;
    _insuranceRank;
    _backGuarantee;
    _duplication;
    _billingComment;
    _adminId;
    _visioPlusDiagnosticInProgress;
    _visioPlusDiagnosticId;
    _checkingToken;
    _withoutSupportedPrice;
    _createdAt;
    _toSuggestAt;
    _suggestedAt;
    _waitInProgressAt;
    _closedAt;
    _validateAt;
    _clientContactedAt;
    _issueDeclaredAt;


    getId() {
        return this._id;
    }

    getPrescriberId() {
        return this._prescriberId;
    }

    getWorkId() {
        return this._workId;
    }

    getExternalId() {
        return this._externalId;
    }

    getOrderComment() {
        return this._orderComment;
    }

    getPrescriberComment() {
        return this._prescriberComment;
    }

    getMaxPrice() {
        return this._maxPrice;
    }

    isMaxPriceSupportPart() {
        return this._maxPriceSupportPart;
    }

    getStatus() {
        return this._status;
    }

    getEndInitiator() {
        return this._endInitiator;
    }

    getEndReason() {
        return this._endReason;
    }

    isClientContacted() {
        return this._clientContacted;
    }

    isCrcSent() {
        return this._crcSent;
    }

    getCrcContent() {
        return this._crcContent;
    }

    getLastTimeUnattributed() {
        return this._lastTimeUnattributed;
    }

    getInsuranceName() {
        return this._insuranceName;
    }

    getInsuranceRank() {
        return this._insuranceRank;
    }

    getBackGuarantee() {
        return this._backGuarantee;
    }

    isDuplication() {
        return this._duplication;
    }

    getBillingComment() {
        return this._billingComment;
    }

    getAdminId() {
        return this._adminId;
    }

    isVisioPlusDiagnosticInProgress() {
        return this._visioPlusDiagnosticInProgress;
    }

    getVisioPlusDiagnosticId() {
        return this._visioPlusDiagnosticId;
    }

    getCheckingToken() {
        return this._checkingToken;
    }

    isWithoutSupportedPrice() {
        return this._withoutSupportedPrice;
    }

    getCreatedAt() {
        return this._createdAt;
    }

    getToSuggestAt() {
        return this._toSuggestAt;
    }

    getSuggestedAt() {
        return this._suggestedAt;
    }

    getWaitInProgressAt() {
        return this._waitInProgressAt;
    }

    getClosedAt() {
        return this._closedAt;
    }

    getValidateAt() {
        return this._validateAt;
    }

    getClientContactedAt() {
        return this._clientContactedAt;
    }

    getIssueDeclaredAt() {
        return this._issueDeclaredAt;
    }

    getClassName() {
        return "order";
    }
}